function Footer() {
  const today=new Date();
    return (
      <footer className='footer'>
        <p>Developed and Maintained by YROS software {today.getFullYear()}. </p>
      </footer>
    )
  }
  
  export default Footer